import { render, staticRenderFns } from "./SmsNewMessageHeader.vue?vue&type=template&id=7b187173&scoped=true&"
import script from "./SmsNewMessageHeader.vue?vue&type=script&lang=js&"
export * from "./SmsNewMessageHeader.vue?vue&type=script&lang=js&"
import style0 from "./SmsNewMessageHeader.vue?vue&type=style&index=0&id=7b187173&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b187173",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Flocal%2Fbamboo-home%2Flocal-working-dir%2F56885249%2FEIPSMS-UB-DB%2Fsrc%2Fcomponents%2FSmsConversation%2FSmsNewMessageHeader.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports